import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)



export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/', 
      name: 'index',
      component:()=>import('../pages/index/index.vue')
    }, 
    {
      path: '/richtext', 
      name: 'richtext',
      component:()=>import('../pages/richtext/richtext.vue')
    },
    {
      path: '/dec', 
      name: 'dec',
      component:()=>import('../pages/dec/dec.vue')
    }, 
    
    {
      path: '/lou', 
      name: 'lou',
      component:()=>import('../pages/lou/lou.vue')
    }, 
    {
      path: '/moredec', 
      name: 'moredec',
      component:()=>import('../pages/moredec/moredec.vue')
    }, 
    {
      path: '/message', 
      name: 'message',
      component:()=>import('../pages/message/message.vue')
    }, 
    {
      path: '/showother', 
      name: 'showother',
      component:()=>import('../pages/showother/showother.vue')
    }, 
    {
      path: '/blog', 
      name: 'blog',
      component:()=>import('../pages/blog/blog.vue')
    }, 
    {
      path: '/testblog', 
      name: 'testblog',
      component:()=>import('../pages/testblog/testblog.vue')
    }, 
    {
      path: '/title', 
      name: 'title',
      component:()=>import('../pages/title/title.vue')
    }, 
   
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js